var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-company-info"},[_vm._v(" 40000+企业部署商用 | 200+产品软著 | 广东省高新技术企业 | 重合同受信用企业 | 科技型中小企业 | 专精特新中小企业 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }